var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z","key":0}),React.createElement("polyline",{"points":"9 22 9 12 15 12 15 22","key":1})]);
}

Home.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-home"};

module.exports = Home;

Home.default = Home;
